var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphicDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 355,
    height: 80,
    viewBox: "0 0 355 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_118_481",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 355,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 355,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_118_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4231 18.5575C111.765 16.4651 137.987 14.6257 164.517 14.3097C194.397 13.9539 224.751 13.6417 254.502 15.7337C269.224 16.7689 283.896 18.4875 298.384 20.5366C311.06 22.3292 324.35 24.3439 335.887 28.5494C340.321 30.1658 345.409 32.392 346.637 36.0071C348.681 42.0249 341.717 47.7242 335.111 50.9226C325.267 55.6888 312.685 58.0236 301.204 60.0215C280.67 63.5949 259.636 65.9833 238.606 67.6482C210.737 69.8545 182.611 70.8831 154.577 71.4133C119.404 72.0785 81.7962 73.1594 47.0746 68.2275C36.2155 66.685 2.95648 61.8026 9.95968 48.4367C15.7397 37.4053 39.7284 32.7779 52.1854 30.1423C79.6691 24.3275 112.451 21.3392 140.655 18.7023C201.567 13.0073 262.599 10.4492 323.973 9",
    stroke: "#0BB3F0",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDesign);
export default __webpack_public_path__ + "static/media/graphic_design.7117aad4a5a2c5ca44c3b34d12767b83.svg";
export { ForwardRef as ReactComponent };